import type { ReactNode } from 'react';

export function Logo({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden>
      <rect width="32" height="32" rx="8" fill="var(--accent)" />
      <path d="M8 21.5 6.5 11l5.2 4.2L16 8.5l4.3 6.7 5.2-4.2L24 21.5z" fill="#fff" />
      <rect x="8" y="23" width="16" height="2.2" rx="1.1" fill="#fff" />
    </svg>
  );
}

/** Centered card used by sign in, sign up, password reset, onboarding and invite pages. */
export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
  width = 'sm',
}: {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  /** Onboarding needs room for choice cards. */
  width?: 'sm' | 'md' | 'lg';
}) {
  return (
    <div className="flex min-h-full items-center justify-center bg-subtle px-4 py-10">
      <div
        className={
          width === 'lg' ? 'w-full max-w-xl' : width === 'md' ? 'w-full max-w-md' : 'w-full max-w-sm'
        }
      >
        <div className="mb-6 flex flex-col items-center text-center">
          <Logo className="mb-4 size-10" />
          <h1 className="text-xl font-semibold tracking-tight">{title}</h1>
          {subtitle ? <p className="mt-1 text-sm text-fg-muted">{subtitle}</p> : null}
        </div>
        <div className="rounded-xl border border-border bg-surface p-6 shadow-sm">{children}</div>
        {footer ? <div className="mt-4 text-center text-sm text-fg-muted">{footer}</div> : null}
      </div>
    </div>
  );
}

/** Only allow same-site relative redirects after sign in. */
/** Paths the Worker renders itself (the OAuth consent page), which the router cannot show. */
export function isServerPage(target: string): boolean {
  return target.startsWith('/api/');
}

export function safeRedirect(target: string | undefined): string {
  return target && target.startsWith('/') && !target.startsWith('//') ? target : '/';
}
